import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AllLeadsDataService } from '../../services/all-leads-data.service';
import { TranslateService } from '@ngx-translate/core';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { TransactionHttpService } from '@core/services/transaction-http.service';
import * as moment from 'moment-timezone';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './extend-lead.component.html',
  styleUrls: ['./extend-lead.component.scss']
})
export class ExtendLeadsDialogComponent implements OnInit, OnDestroy {

  @ViewChildren('focusfield') focusfield: QueryList<ElementRef>;
  form: FormGroup;
  dropdown = {
    merchantSites: [],
  };

  allTelemarketerDropdownList = [];
  telemarketerDropdownSettings = {};
  telemarketerSelectedItems = [];
  telemarketerDropdownList = [];

  statuesDropdownSettings = {};
  statuesSelectedItems = [];
  statuesDropdownList = this.dropdownHttpService.leadStatues.filter(x => x.id != 0 && x.id != 8);

  leadsDropdownSettings = {};
  leadsSelectedItems = [];
  leadsDropdownList = [];

  ranges: any;
  dateTimePickerLocale = this.transactionHttpService.dateTimePickerLocale;
  invalidDateRange = false;
  timezone = JSON.parse(localStorage.getItem('user_data')).timezone;

  data$ = this.allLeadsDataService.data$;
  messages$ = this.allLeadsDataService.messages$;

  refreshStatus: boolean;
  buttonLoading: boolean;

  private subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { leadID: any},
    public dialogRef: MatDialogRef<ExtendLeadsDialogComponent>,
    private allLeadsDataService: AllLeadsDataService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private dropdownHttpService: DropdownHttpService,
    private transactionHttpService: TransactionHttpService,
  ) { }

  ngOnInit() {
    this.formInit();

    this.allLeadsDataService.getTelemarketerList(``).subscribe(res => {
      this.allTelemarketerDropdownList = res;
      this.telemarketerDropdownList = this.allTelemarketerDropdownList.filter((value, index, self) => 
        self.findIndex(v => v.id === value.id) === index
      );

      this.telemarketerDropdownList.sort((a, b) => a.username.localeCompare(b.username));

      if (this.data.leadID !== undefined) {
        this.telemarketerSelectedItems = this.telemarketerDropdownList.filter(x => x.id == this.data.leadID.lead_telemarketer_id);
        this.statuesSelectedItems = this.statuesDropdownList.filter(x => x.id == this.data.leadID.status);
        this.form.patchValue({
          defaultDate: {
            startDate: moment(this.data.leadID.lead_assigned_date).format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(this.data.leadID.lead_assigned_date).format('YYYY-MM-DD HH:mm:ss'),
          },
          start_date: this.data.leadID.lead_assigned_date,
          end_date: this.data.leadID.lead_assigned_date,
          status: [this.data.leadID.status],
        });
        this.cdr.detectChanges();
        let data = [];

        data['telemarketer_id'] = this.data.leadID.lead_telemarketer_id;
        data['start_date'] = moment(this.data.leadID.lead_assigned_date).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
        data['end_date'] = moment(this.data.leadID.lead_assigned_date).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
        data['status'] = this.data.leadID.status;

        let params = Object.keys(data)
            .map((key) => key + "=" + data[key])
            .join("&");

        this.allLeadsDataService.getTelemarketerExtendLeads(params).subscribe(res => {
          this.leadsDropdownList = res['available_leads'];
          this.leadsDropdownList.map(function (elm) {
            if (elm.username != null) {
              elm['labelKey'] = elm.username + ' (' + elm.id + ')';
            } else {
              elm['labelKey'] = '(' + elm.id + ')';
            }
          });

          this.leadsSelectedItems = this.leadsDropdownList.filter(x => x.id == this.data.leadID.lead_id);
          this.form.patchValue({
            telemarketer_id: this.data.leadID.lead_telemarketer_id,
            lead_ids: [this.data.leadID.lead_id],
          })

          this.cdr.detectChanges();
        });
      }
      else {
        this.form.patchValue({ 
          telemarketer_id: null,
          lead_ids: null,
        });
      }
    });

    this.telemarketerDropdownSettings = {
      autoPosition: false,
      singleSelection: true,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'username',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false
    };

    this.statuesDropdownSettings = {
      autoPosition: false,
      singleSelection: false,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'name',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false,
    };

    this.leadsDropdownSettings = {
      autoPosition: false,
      singleSelection: false,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'labelKey',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false,
    };
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.onRefresh();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
  
  onSubmit() {
    this.buttonLoading = true;

    const data = {
      ...this.form.value,
    };
    
    data['start_date'] = moment(data['start_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
    data['end_date'] = moment(data['end_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
    data['status'] = Object.values(data['status']).join(',');
    delete data['defaultDate'];  

    this.subscription = this.allLeadsDataService.extendLead(data).pipe(
      tap((res) => {
        this.dialogRef.close();
        this.form.setErrors(null);
        //this.dialogRef.close(true);
        this.buttonLoading = false;
        this.refreshStatus = true;
      }),
      catchError((error) => {
        this.form.setErrors(null);
        this.buttonLoading = false;
        this.refreshStatus = false;
        throw error;
      })
    ).subscribe();
  }

  onRefresh() {
    if (this.refreshStatus === true) {
      this.dialogRef.close(true);
    }
  }

  private formInit() {
    this.form = new FormGroup({
      telemarketer_id: new FormControl(null, [Validators.required]),
      lead_ids: new FormControl(null, [Validators.required]),
      status: new FormControl([]),
      start_date: new FormControl(null),
      end_date: new FormControl(null),
      defaultDate: new FormControl(null),
    });

    this.cdr.detectChanges();
  }

  getExtendLead() {
    if (this.form.value.telemarketer_id && this.form.value.status.length > 0 && this.form.value.start_date && this.form.value.end_date && !this.invalidDateRange) {
      of(this.form.value)
      .pipe(
        map(this.filterFormFields),
        tap((data) => {
          data['start_date'] = moment(data['start_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
          data['end_date'] = moment(data['end_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');

          let params = Object.keys(data)
            .map((key) => key + "=" + data[key])
            .join("&");

          this.subscription.unsubscribe();
          this.subscription = this.allLeadsDataService.getTelemarketerExtendLeads(params).subscribe(res => {
            this.leadsDropdownList = res['available_leads'];
            this.leadsDropdownList.map(function (elm) {
              if (elm.username != null) {
                elm['labelKey'] = elm.username + ' (' + elm.id + ') - ' + elm.lead_status_name;
              } else {
                elm['labelKey'] = '(' + elm.id + ') - ' + elm.lead_status_name;
              }
            });
          });
        },
        catchError((error) => {
          this.buttonLoading = false;
          this.form.setErrors(null);
          throw error;
        })
      )).subscribe();
    }
  }

  onSelectTelemarketer(event: any) {
    this.resetLead();
    if (event.length > 0) {
      this.telemarketerSelectedItems = event;
      this.form.patchValue({
        telemarketer_id: this.telemarketerSelectedItems[0].id
      })
      
      this.getExtendLead();
    }
    else {
      this.form.patchValue({ 
        telemarketer_id: null,
      });

      this.telemarketerSelectedItems = [];
    }
    
    this.cdr.detectChanges();
  }

  onSelectStatus(event: any) {
    this.resetLead();
    if (event.length > 0) {
      setTimeout(() => {
        this.getExtendLead();
      }, 500);
    }
    else {
      this.form.patchValue({ 
        status: [],
      });

      this.statuesSelectedItems = [];
    }
    this.cdr.detectChanges();
  }

  onDateRange(event: any) {
    this.resetLead();
    this.invalidDateRange = false;
    this.form.patchValue({
      start_date: event.startDate !== null && event.startDate !== undefined ? event.startDate : null,
      end_date: event.endDate !== null && event.endDate !== undefined ? event.endDate : null
    });

    if (event) {
      if (event.startDate && event.endDate && event.endDate.diff(event.startDate, 'days') > 31) {
        this.invalidDateRange = true;
      }
      else {
        this.getExtendLead();
        this.invalidDateRange = false;
      }

      this.cdr.detectChanges();
    }
  }

  resetLead() {
    this.form.patchValue({ 
      lead_ids: null,
    });
    this.leadsSelectedItems = [];
    this.leadsDropdownList = [];
  }

  onClearDate() {
    if (this.form.value.start_date !== null) {
      this.form.patchValue({ defaultDate: null });
      this.invalidDateRange = false;
    }
  }

  updateDateRange() {
    this.ranges = this.transactionHttpService.updateDateRange();
  }

  onConfirmation() {
    Swal.fire({
      icon: "info",
      title: `<div>Extend Lead Confirmation</div>`,
      html: `Are you sure you want to extend lead(s) validity period?`,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        this.onSubmit();
      }
    });
  }

  private filterFormFields(formData: any) {
    const fields = {};
    Object.keys(formData).forEach(key => {
      if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined && formData[key] !== false && key !== 'defaultDate' && key !== 'contactType') {
        fields[key] = formData[key];
      }
    });
    return fields;
  }
}
